import { OverlayTrigger } from "react-bootstrap";
import type { CellProps } from "react-table";

import { ConversationIndicator } from "../../../../../components/ConversationIndicator/ConversationIndicator";
import { DotDivider } from "../../../../../components/DotDivider/DotDivider";
import { ShieldIcon } from "../../../../../components/icons";
import { RelatedIcon } from "../../../../../components/icons/RelatedIcon";
import { renderTooltip } from "../../../../../components/StyledTooltip/StyledTooltip";
import { cacheTypes } from "../../../../../constants/cacheTypes";
import type { IApplication } from "../../../../../hooks/reactQueryHooks/useApplications";
import type { IData } from "../../../../../types";

interface ItemColumnProps {
  cellProps: CellProps<IData>;
  applications: IApplication[];
}

const ItemColumn = ({ cellProps, applications }: ItemColumnProps) => {
  const { row } = cellProps;
  const {
    prompt,
    applicationId: projId,
    metadata,
    promptType,
    quantityOfUserMessages,
  } = row.original;
  const applicationId = projId || "eaf30170-b9f3-427e-ac18-1a049e52ac8c";
  const applicationName = applications?.find(
    app => app.id === applicationId,
  )?.name;

  return (
    <div className="d-flex w-auto align-content-md-start ">
      <div className="custom-column-name">
        <div className="d-flex align-items-center fs-9 fw-500">
          {applicationName}
          {cacheTypes[promptType] && (
            <>
              <DotDivider />
              {cacheTypes[promptType]}
            </>
          )}
          {!!row?.original.similarPromptsCount && (
            <>
              <DotDivider />
              <OverlayTrigger
                placement="bottom"
                overlay={renderTooltip(
                  `${row.original.similarPromptsCount} similar prompt${
                    row.original.similarPromptsCount > 1 ? "s" : ""
                  }`,
                )}
              >
                <span className="similarity-count">
                  <span className="align-items-center">
                    <RelatedIcon />
                  </span>
                  <span className="align-text-bottom">
                    {row?.original.similarPromptsCount}
                  </span>
                </span>
              </OverlayTrigger>
            </>
          )}
          {quantityOfUserMessages > 2 && (
            <>
              <DotDivider />
              <ConversationIndicator
                popupText="This item is part of a conversation"
                value={quantityOfUserMessages}
              />
            </>
          )}
          {metadata?.isUserModified && (
            <>
              <DotDivider />
              <OverlayTrigger
                placement="bottom"
                overlay={renderTooltip("This item was modified by a human.")}
              >
                <span className="verify-label d-flex align-items-center">
                  <span className="me-1 ">
                    <ShieldIcon size={12} />
                  </span>
                  <span className="align-text-bottom">Human reviewed</span>
                </span>
              </OverlayTrigger>
            </>
          )}
        </div>

        <div className="d-flex align-items-start">
          <div className="me-1 two-lines-text" title={prompt}>
            {prompt}
          </div>
        </div>
      </div>
    </div>
  );
};

export { ItemColumn };
